import { configureStore } from '@reduxjs/toolkit';
import userReducer from './user'; // Import the default export (the reducer)
import emailReducer from './email';
import propertyFilterReducer from './propertyfilter'; // Import the default export (the reducer)
const store = configureStore({
  reducer: {
    user: userReducer, // Use the imported reducer function
    email:emailReducer,
    propertyFilter:propertyFilterReducer
  },
});

export default store;